var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-results" },
    [
      _c("search-results-tabs", { on: { "change-tab": _vm.changeTab } }),
      _c("search-results-grid", {
        attrs: {
          "search-results": _vm.searchResults,
          "current-tab": _vm.currentTab,
          "search-term": _vm.term,
          "search-cta-settings": _vm.searchCtaSettings
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }